import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyCatalog = lazy(() => import('./Catalog'));

export const Catalog: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyCatalog {...props} />
	</Suspense>
);
